import { render } from "./InternalBilling.vue?vue&type=template&id=608472d6&scoped=true"
import script from "./InternalBilling.vue?vue&type=script&lang=js"
export * from "./InternalBilling.vue?vue&type=script&lang=js"

import "./InternalBilling.vue?vue&type=style&index=0&id=608472d6&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608472d6"]])

export default __exports__